<template>
  <div>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="profileModalActive">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{this.$t('updateModel', {field: this.$t('profile')})}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="toggleProfileModal()" dark icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-tabs color="primary" dark v-model="tab">
        <v-tab>{{$t('userInformation')}}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <tab-information></tab-information>
        </v-tab-item>
      </v-tabs-items>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import tabInformation from './tabInformation'
import { dateFormat, timeFormat } from '../../../helpers/dateHelper'

export default {
  name: 'ProfileView',
  components: { tabInformation },
  props: {},
  data () {
    return {
      tab: 0,
      date: new Date()
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions({
      toggleProfileModal: 'authentication/toggleProfileModal',
      countryInit: 'countries/setInit',
      provinceInit: 'provinces/setInit',
      cityInit: 'cities/setInit',
      rolInit: 'rols/setInit',
      entityInit: 'entities/setInit',
      teamInit: 'teams/setInit',
      tournamentInit: 'tournaments/setInit',
      usersInit: 'users/setInit'
    }),
    initData () {
      this.countryInit()
      this.provinceInit()
      this.cityInit()
      this.rolInit()
      this.entityInit()
      this.teamInit()
      this.tournamentInit()
      // this.usersInit()
    },
    close () {},

    dateFormat (date) {
      return dateFormat(date)
    }
  },
  computed: {
    ...mapState({
      profileModalActive: state => state.authentication.profileModalActive
    })
  },
  watch: {
    profileModalActive: function (val) {
      if (val) this.initData()
    }
  }
}
</script>
